import React from 'react';
import { Text, Tooltip } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { MembershipV2 } from '../../apollo/queries';
import useOrganisationsNameMutation, {
  OrganisationsByName,
} from '../../pages/hooks/useOrganisationsName.mutation';

interface Props {
  memberships: MembershipV2[];
}

const StyledOrgContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
  max-height: 120px;
  overflow-y: scroll;
  row-gap: 3px;
`;

const ThreeDotStyled = styled.span`
  text-align: center;
`;

interface OrgListProps {
  organisations: OrganisationsByName[];
}

const OrganisationNameList = ({ organisations }: OrgListProps): any => {
  return (
    <StyledOrgContainer>
      {organisations.length === 0 ? (
        <ThreeDotStyled>...</ThreeDotStyled>
      ) : (
        <React.Fragment>
          {organisations.map((o: any) => (
            <div key={o.name}>{o.name}</div>
          ))}
        </React.Fragment>
      )}
    </StyledOrgContainer>
  );
};

const ShowMoreOrganisations = ({ memberships }: Props) => {
  const [getOrgNames, { organisations }] = useOrganisationsNameMutation();
  const tooltipId = memberships.map((m) => m.organisation.trim()).join('-');

  return (
    <div
      onMouseEnter={() => {
        getOrgNames(memberships.map((m) => m.organisation));
      }}
    >
      <Tooltip
        content={<OrganisationNameList organisations={organisations} />}
        id={tooltipId}
        position="bottom"
        delayHide={500}
        clickable
      >
        <Text variant="body-medium" weight="light" color="primary.100">
          {`+${memberships.length} more`}
        </Text>
      </Tooltip>
    </div>
  );
};

export default ShowMoreOrganisations;
